import { FormattedMessage } from 'react-intl';

type Messages<Names extends keyof any = string> = {
    [key in Names]: any;
};

type MessageValue = {
    [key: string]: string | number | boolean | Date | null | undefined;
};

export function IwDynamicFormattedMessage({
    messages = {},
    messageKey,
    defaultMessage = '',
    values
}: {
    messages?: Messages;
    messageKey: string;
    defaultMessage?: string;
    values?: MessageValue;
}) {
    if (!messages[messageKey]) {
        return <span>{defaultMessage}</span>;
    }

    return <FormattedMessage {...messages[messageKey]} values={values} />;
}
